import { NgModule } from '@angular/core';
import { NewStepSliderComponent } from './new-step-slider.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UtilsService } from '@library/utils/services/utils.service';
import { AtomsModule } from '@library/ui/atoms/atoms.module';

@NgModule({
  declarations: [NewStepSliderComponent],
  imports: [
    CommonModule,
    FormsModule,
    AtomsModule,
  ],
  exports: [NewStepSliderComponent],
  providers: [
    UtilsService,
  ]
})
export class NewStepSliderModule { }
